import React from 'react';
import PropTypes from 'prop-types';
import flow from 'lodash/flow';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classnames from 'classnames';
import { Link } from '~spa/Components/Link/Link';
import {
    getIsMobileWrapperFlag,
} from '~shared/utils/user';
import i18n from '~shared/utils/i18n';

import * as betfeedActions from '../actions/betfeedWidgetActions';
import WidgetContainer from '~shared/ui/WidgetContainer';
import Carousel from '~shared/ui/Carousel';
import MessageButtonCard from '~spa/Components/MessageButtonCard';

import { BetFeedContainer } from '../../app/containers/BetFeedContainer';
import BetCardContainer from '~shared/components/react/BetCardClassic/BetCardContainer';
import {
    getGaAttributeObject,
    getGaAttributeValueSportPage,
    getGaAttributeValueHomepageWidget,
} from '~shared/utils/google-analytics';
import findKey from 'lodash/findKey';
import { withLazyLoadContext } from '~spa/Components/LazyLoad/LazyLoad';

import {
    BB_BETFEED_FILTER_MOST_POPULAR,
    BB_BETFEED_WIDGET_COMPONENT_CLASS,
    BB_BETFEED_CSS_ID_PREFIX,
    BB_BETFEED_WIDGET_BETFEED_URL,
    BB_BETFEED_WIDGET_HEADER_TEXT_TITLE,
    BB_BETFEED_WIDGET_HEADER_SPORTS_TEXT_TITLE,
    BB_BETFEED_WIDGET_FOOTER_SPORTS_TEXT_TITLE,
    BB_BETFEED_WIDGET_HEADER_ICON_TITLE,
    BB_BETFEED_WIDGET_CAROUSEL_NAV_NEXT,
    BB_BETFEED_WIDGET_CAROUSEL_NAV_PREV,
    BB_BETFEED_FILTER_QUERY_KEY,
    BB_BETFEED_FILTER_MOST_RECENT,
    BB_BETFEED_FILTER_BET_TYPES_DEFAULT,
    GTM_MAIN_COMPONENT,
    GTM_SUB_COMPONENT,
    GTM_ACTION_SWIPE,
    GTM_ACTION_SEE_ALL,
    INSTRUCTION_CONTENT_MOBILE,
    INSTRUCTION_CONTENT_WEB,
    BETFEED_SLIDES_PER_VIEW,
    BB_BETFEED_FOOTER_NAME,
    BB_BETFEED_FOOTER_TYPE,
    BETFEED_NEXT_CLASS,
    BETFEED_PREV_CLASS,
    BB_BETFEED_LOADING_STATES,
} from '../../constants';
import {
    BETFEED_INSTRUCTION_CARD,
} from '~shared/components/instruction-card/constants/constants';
import InstructionCard from '~shared/components/instruction-card/InstructionCard';
import { isIndividualPage } from '~scenes/sport/horse-racing/utils';
import LoadingIndicator from '~shared/components/react/LoadingIndicator';

export class BetFeedWidgetContainer extends BetFeedContainer {

    _constructor() {
        this.refreshBets = this.refreshBets.bind(this);
        this.resetSelectedSports = this.resetSelectedSports.bind(this);
        this.wsEventListener = this.wsEventListener.bind(this);
        this.wsEventListenerNumberOfPeopleBets = this.wsEventListenerNumberOfPeopleBets.bind(this);
        this.getI18nSportName = this.getI18nSportName.bind(this);
    }

    static propTypes = {
        betCards: PropTypes.array,
        updateCommonStoreWsData: PropTypes.func,
        updateNumberOfPeopleBetsWsData: PropTypes.func,
        getBetCards: PropTypes.func,
        commonDataEvents: PropTypes.object,
        sportName: PropTypes.string,
        sportSlug: PropTypes.string,
        selectFilterOption: PropTypes.func,
        updateWidgetSport: PropTypes.func,
        lazyLoadHasLoaded: PropTypes.func,
        lazyLoadIsEmpty: PropTypes.func,
        displayType: PropTypes.string,
        loadingState: PropTypes.string,
    };

    static defaultProps = {
        lazyLoadHasLoaded: () => null,
        lazyLoadIsEmpty: () => null,
    };

    get isSportPage() {
        return this.props.sportSlug && this.props.sportName;
    }

    get gtmSource() {
        const source = this.isSportPage ? this.props.sportSlug : GTM_MAIN_COMPONENT;

        return source;
    }

    componentDidUpdate(prevProps) {
        if (this.props.sportSlug !== prevProps.sportSlug) {
            this.props.updateWidgetSport(
                this.props.sportSlug,
                this.props.sportName
            );
            this.refreshBets();
        }

        //for not calling parent method
        return null;
    }

    componentDidMount() {
        this.refreshBets();
    }

    getI18nSportName() {
        const objKeyForAnEventForThisSport = findKey(this.props.commonDataEvents, event => event.sport_slug === this.props.sportSlug);
        /**
         * SPA: If we switch from (e.g.) horses to dogs, we might have horses in the commonDataStore, but no bets
         * for the dogs betfeed widget. In this case objKeyForAnEventForThisSport is undefined
         */
        if (!objKeyForAnEventForThisSport) {
            return '';
        }

        // belt and braces: sport_name should be defined, but commonDataStore can be populated from disparate sources.
        return this.props.commonDataEvents[objKeyForAnEventForThisSport].sport_name
               || this.props.commonDataEvents[objKeyForAnEventForThisSport].sport;
    }

    refreshBets() {
        this.props.getBetCards(this.wsEventListener, this.wsEventListenerNumberOfPeopleBets, {
            lazyLoadHasLoaded: this.props.lazyLoadHasLoaded,
            lazyLoadIsEmpty: this.props.lazyLoadIsEmpty,
        });
    }

    resetSelectedSports() {
        // @todo [SPA]: Currently the result of it will be visible after page reload
        // It requires significant BetFeed architecture changes and change
        // communication between widget and betfeed page.
        const { sportSlug } = this.props;
        const sortBy = this.isSportPage ? BB_BETFEED_FILTER_MOST_POPULAR : BB_BETFEED_FILTER_MOST_RECENT;
        const betType = BB_BETFEED_FILTER_BET_TYPES_DEFAULT;
        let sports = '';

        if (this.isSportPage) {
            sports = sportSlug;
        }

        localStorage.setItem(BB_BETFEED_FILTER_QUERY_KEY, JSON.stringify({
            sortBy,
            sports,
            betType,
        }));
    }

    getSliderArrows(cName) {
        if (getIsMobileWrapperFlag()) {
            return null;
        }

        return React.createElement('div', {className: cName});
    }

    carouselOptions = {
        autoplay: false,
        lazy: false,
        navigation: {
            prevEl: `.${BETFEED_PREV_CLASS}`,
            nextEl: `.${BETFEED_NEXT_CLASS}`,
        },
        slidesPerView: BETFEED_SLIDES_PER_VIEW,
    };

    render() {
        const { betCards, loadingState, displayType } = this.props;
        const sport = this.getI18nSportName();
        const widgetTitle = sport
            ? i18n.t(BB_BETFEED_WIDGET_HEADER_SPORTS_TEXT_TITLE, {sport})
            : i18n.t(BB_BETFEED_WIDGET_HEADER_TEXT_TITLE);
        const isMobile = getIsMobileWrapperFlag();
        const instructionContent = isMobile ? i18n.t(INSTRUCTION_CONTENT_MOBILE) : i18n.t(INSTRUCTION_CONTENT_WEB);
        const betfeed = i18n.t(BB_BETFEED_FOOTER_NAME);
        const hasData = Boolean(betCards && betCards.length);
        const seeMoreBetsText = i18n.t(BB_BETFEED_WIDGET_FOOTER_SPORTS_TEXT_TITLE, {sport});
        const { LOADING } = BB_BETFEED_LOADING_STATES;

        if (isIndividualPage(displayType) && (!loadingState || loadingState === LOADING)) {

            return (
                <div className={BB_BETFEED_WIDGET_COMPONENT_CLASS}>
                    <LoadingIndicator />
                </div>
            );
        }

        if (!hasData) {
            if (isIndividualPage(displayType)) {
                return (
                    <MessageButtonCard
                    MessageIconClassName="no-results"
                    message={i18n.t('racing.no_results')} />
                );
            }

            return null;
        }

        const gaComponentValue = this.isSportPage
            ? getGaAttributeValueSportPage(this.props.sportSlug, 'betfeed')
            : getGaAttributeValueHomepageWidget('betfeed');
        const gaComponentAttribute = getGaAttributeObject(gaComponentValue);

        return (
            <div className={BB_BETFEED_WIDGET_COMPONENT_CLASS}>
            {
                !isIndividualPage(displayType) ?
                <WidgetContainer
                    title={widgetTitle}
                    titleIconClassName={BB_BETFEED_WIDGET_HEADER_ICON_TITLE}
                    titleLink={BB_BETFEED_WIDGET_BETFEED_URL}
                    onClick={this.resetSelectedSports()}
                    gtmAttribute={`${this.gtmSource};${GTM_SUB_COMPONENT};${GTM_ACTION_SEE_ALL}`}
                    gaComponent={gaComponentValue}
                    previousArrow={this.getSliderArrows(classnames(BB_BETFEED_WIDGET_CAROUSEL_NAV_PREV, BETFEED_PREV_CLASS))}
                    nextArrow={this.getSliderArrows(classnames(BB_BETFEED_WIDGET_CAROUSEL_NAV_NEXT, BETFEED_NEXT_CLASS))}
                >
                    <Carousel
                        options={this.carouselOptions}
                        gtmAttribute={`${this.gtmSource};${GTM_SUB_COMPONENT};${GTM_ACTION_SWIPE}`}
                        customNav={true}
                        isMobile={isMobile}
                    >
                        <InstructionCard
                            contentText={instructionContent}
                            type={BETFEED_INSTRUCTION_CARD}
                            gtmAttribute={`${this.gtmSource};${GTM_SUB_COMPONENT};`}
                        />
                        {this.props.betCards.map((betcard, index) =>
                            <div key={betcard.betcard_id}>
                                <BetCardContainer
                                    betcard={{...betcard, position: index }}
                                    sportName={sport || betfeed}
                                    commonDataEvents={this.getBetcardEventTree(betcard)}
                                    cssIdPrefix={BB_BETFEED_CSS_ID_PREFIX}
                                    gtmAttribute={`${this.gtmSource};${GTM_SUB_COMPONENT}`}
                                    footerType={BB_BETFEED_FOOTER_TYPE}
                                />
                            </div>
                        )}
                    </Carousel>
                </WidgetContainer> :
                <div { ...gaComponentAttribute } className="c-widgetcontainer__as-page">
                    {
                        this.props.betCards.map((betcard, index) =>
                            <div key={betcard.betcard_id}>
                                <BetCardContainer
                                    betcard={{...betcard, position: index }}
                                    sportName={sport || betfeed}
                                    commonDataEvents={this.getBetcardEventTree(betcard)}
                                    cssIdPrefix={BB_BETFEED_CSS_ID_PREFIX}
                                    gtmAttribute={`${this.gtmSource};${GTM_SUB_COMPONENT}`}
                                    footerType={BB_BETFEED_FOOTER_TYPE}
                                />
                            </div>
                        )
                    }
                    <h2>
                        <Link
                            className="c-widgetcontainer__see-all"
                            to={BB_BETFEED_WIDGET_BETFEED_URL}
                            onClick={this.resetSelectedSports()}
                            gtmAttribute={`${this.gtmSource};${GTM_SUB_COMPONENT};${GTM_ACTION_SEE_ALL}`}
                        >
                            {seeMoreBetsText}
                        </Link>
                    </h2>
                </div>
                }
            </div>
        );
    }
}

/**
 * React-redux bindings
 * @param {*} state the current state
 * @param {*} ownProps component own props
 * @returns {object} props
 */
function mapStateToProps(state, ownProps) {
    return {
        betCards: state.betcards.betCards,
        commonDataEvents: state.commonData,
        filter: state.betcards.filter,
        loadingState: state.betcards.loadingState,
        sportName: ownProps.sportName,
        sportSlug: ownProps.sportSlug,
    };
}

/**
 * React-redux bindings
 * @param {*} dispatch the dispatcher function
 * @returns {object} betfeed actions
 */
function mapDispatchToProps(dispatch) {
    return bindActionCreators(betfeedActions, dispatch);
}

export default flow(
    withLazyLoadContext(),
    connect(mapStateToProps, mapDispatchToProps),
)(BetFeedWidgetContainer);
